import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import KNDatePickerNext from 'components/KNDatePicker/KNDatePickerNext'
import { getFieldErrorMessages } from 'global/helpers/form'
import type { KNFormDateProps } from './types'

const DEFAULT_MIN_DATE = new Date(1970, 0, 1)
const DEFAULT_MAX_DATE = new Date(2100, 0, 1)

const KNFormDate = <T extends FieldValues>({
  name,
  control,
  rules,
  label,
  disabled,
  sx,
  minDate,
  maxDate,
}: KNFormDateProps<T>): ReactElement => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { invalid, error }, formState }): ReactElement => (
        <FormControl fullWidth sx={sx} error={invalid}>
          <KNDatePickerNext
            mode="single"
            label={label}
            value={value ?? undefined}
            minDate={minDate ?? DEFAULT_MIN_DATE}
            maxDate={maxDate ?? DEFAULT_MAX_DATE}
            error={invalid}
            disabled={disabled || formState.isSubmitting}
            onChange={(newValue): void => {
              onChange(newValue ?? null)
            }}
          />
          {error?.message && <FormHelperText>{getFieldErrorMessages(error)}</FormHelperText>}
        </FormControl>
      )}
    />
  )
}

export default KNFormDate
